import React from "react";
import { MdDesignServices, MdOutlineSchool } from "react-icons/md";
import { FiCodesandbox } from "react-icons/fi";
import { CgWebsite } from "react-icons/cg";
import styled from "styled-components";
import Card from "./Card";
import { Slide } from "react-awesome-reveal";

const Services = () => {
  return (
    <Container id="service">
      <Slide direction="down">
        <h4>
          My{" "}
          <span className="green" id="education">
            Education
          </span>
        </h4>
        <h1>Where I Study</h1>
      </Slide>
      <Cards>
        <Slide direction="left">
          <Card
            Icon={MdOutlineSchool}
            title={"10th Standard"}
            disc={`Saratha Matriculation Higher Secondary School`}
          />
        </Slide>
        <Slide direction="up">
          <Card
            Icon={MdOutlineSchool}
            title={"12th Standard"}
            disc={`Saratha Matriculation Higher Secondary School`}
          />
        </Slide>
        <Slide direction="right">
          <Card
            Icon={MdOutlineSchool}
            title={"BE-Instrumentation and Control"}
            disc={`PSG College of Technology`}
          />
        </Slide>
      </Cards>
    </Container>
  );
};

export default Services;

const Container = styled.div`
  width: 80%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 3rem 0;
  @media (max-width: 840px) {
    width: 90%;
  }

  h1 {
    padding-top: 1rem;
  }
`;
const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  margin-top: 4rem;
  gap: 1rem;
`;
